import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import IngredientCreateForm from '~/containers/ingredientCreate/ingredientCreate';

export class IngredientCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/ingredients`}>
        <Button color="secondary">Cancel</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/ingredients" backText="Ingredients" title="Add ingredient" button={cancelButton} />
        <IngredientCreateForm />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(IngredientCreatePage));



// WEBPACK FOOTER //
// ./src/pages/ingredientCreate/ingredientCreate.jsx